import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { ReferrerActionTypes } from './referrer.types';
import referrerActions from './referrer.actions';
import { config } from '@/config';
import commonActions from '@/redux/modules/common/common.actions';
import { locale } from '@/utils/locale';

function* getExtoleJwt() {
  const { token } = yield select(state => state.auth);

  yield put(referrerActions.referrer.extoleJwt.setLoading(true));

  try {
    const request = {
      headers: {
        Authorization: token,
      },
      url: `${config.WHMCS_URL}/api/v2/portal/referral/jwt`,
    };

    const response = yield call(api.whmcs.get, request);

    yield put(referrerActions.referrer.extoleJwt.success(response.data));
  } catch (e) {
    yield put(
      commonActions.notifications.set({
        toast: {
          showIcon: true,
          title: locale('referrerFriend.genericError.title'),
          info: locale('referrerFriend.genericError.info'),
          context: 'error',
        },
        maxWidth: '460px',
      }),
    );
    yield put(referrerActions.referrer.extoleJwt.failure());
  }

  yield put(referrerActions.referrer.extoleJwt.setLoading(false));
}

function* sagas() {
  yield takeLatest(ReferrerActionTypes.REQUEST_EXTOLE_JWT, getExtoleJwt);
}

export default sagas;
